import { prodapiAxiosClient } from "./prodApiClient";

const newProduct = (data) => {
    return prodapiAxiosClient
    .post("/api/v1/camera/newproduct", data)
}

const productApi = {newProduct}
export default productApi;